"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _devConsoleLog = require("../_util/devConsoleLog");
var _customIcon = _interopRequireDefault(require("./customIcon"));
var _svgBaseProps = _interopRequireDefault(require("./utils/svgBaseProps"));
var _jsxRuntime = require("react/jsx-runtime");
const Icon = props => {
  const {
    type,
    spin,
    block,
    rotate,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-icon");
  (0, _devConsoleLog.error)(!type, 'Icon', 'The “type” parameter must have');
  const svg = (type || '').split('/').filter(p => !!p).pop();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ..._svgBaseProps.default,
    ...restProps,
    className: (0, _classnames.default)(className, baseClassName, {
      ["".concat(baseClassName, "-anticon-spin")]: !!spin || svg === 'LoadingOutlined' || svg === 'Loading3QuartersOutlined'
    }),
    style: {
      ...style,
      ...(block ? {
        display: 'block'
      } : {}),
      ...(rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
      } : {})
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
      xlinkHref: "#".concat(svg)
    })
  });
};
Icon.CustomIcon = _customIcon.default;
var _default = exports.default = Icon;